<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection :text="(id) ? 'Editar conexión' : 'Crear conexión'" :breadcrumb="true" />
			</template>
		</LayoutHeaderSection>
		<main class="pt-8 vstack gap-10">
			<CommonFormWrapper submitText="Guardar" :cancelUrl="{ name: 'company.admin.synchronizer.index' }" :submitting="submitting" :errors="validationExternal" @submit="submit" v-if="!loading">
				<template #body>
					<CommonFormInputText v-model="target.name" title="Nombre" placeholder="Ingrese un nombre" :validation="validation.name" />
					<CompanyAdminSynchronizerTypeApi v-model="target.config" v-if="target.type == 'api'" />
					<CommonFormInputCheckbox v-model="target.capabilities" title="Capacidades" :options="capabilitiesOptions" />
				</template>
			</CommonFormWrapper>
		</main>
	</div>
</template>

<script>
	import { reactive, computed, onBeforeMount, inject } from 'vue';
	import router from '@/router';
	import _ from 'lodash';
	import moment from 'moment';
	import useVuelidate from '@vuelidate/core';
	import { required, minLength, maxLength } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import CompanyAdminSynchronizerRepository from '@/repositories/modules/Company/Admin/Synchronizer';

	export default {
		props: {
			id: String
		},
		setup(props) {
			const $env = inject('$env');
			const { loading, submitting, validationExternal, catchError } = composableForm();
			const capabilitiesOptions = computed(() => _.mapValues($env.MODEL.Synchronizer.capabilities, (capability) => `${capability.title}<div class="d-block text-muted lh-sm">${capability.description}</div>`));

			const target = reactive({
				id: null,
				type: 'api',
				name: null,
				config: {},
				capabilities: []
			});

			const validation = useVuelidate({
				type: {
					required
				},
				name: {
					required,
					minLength: minLength(3),
					maxLength: maxLength(150)
				}
			}, target);

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];
				if(!await validation.value.$validate()) return;

				submitting.value = true;

				if(props.id != undefined) {
					await CompanyAdminSynchronizerRepository.update(props.id, target).then(redirect).catch(catchError);
				}else{
					await CompanyAdminSynchronizerRepository.store(target).then(redirect).catch(catchError);
				}

				submitting.value = false;
			}

			const redirect = (response) => {
				if(response.data.type == 'api' && !response.data.has_token) router.push({ name: 'company.admin.synchronizer.token', params: { id: response.data.id }});
				else router.push({ name: 'company.admin.synchronizer.index' });
			}

			onBeforeMount(async () => {
				if(props.id != undefined) {
					await CompanyAdminSynchronizerRepository.show(props.id).then((response) => {
						if(response.data.config == null || Array.isArray(response.data.config)) {
							response.data.config = {};
						}

						if(response.data.capabilities == null) {
							response.data.capabilities = [];
						}

						Object.assign(target, response.data);
					}).catch((e) => {
						catchError(e);
						router.push({ name: `company.admin.synchronizer.index` });
					});
				}

				loading.value = false;
			});

			return { loading, capabilitiesOptions, target, submit, submitting, validation, validationExternal };
		}
	}
</script>